import React from 'react';
import styled from 'styled-components';
import IconRemote from '../../../../../../assets/icons/IconRemote.svg';
import TextHelper from '../../../../../../core/helpers/TextHelper';
import { Icon } from '../../../../../components';
import IconClass from '@/assets/icons/IconClassBlack.svg';
import ButtonZoom from '../../../components/ButtonZoom';
import { Div, Line } from './InPersonEventBox';
import Link from '@/presentation/reusables/Link';

const Container = styled.div`
  align-items: flex-start;
  padding: 12px;
  margin: 24px 0 16px 0;
  width: 100%;
  background: #f7fafb;
  border: 1px solid var(--card-focus);
  border-radius: 8px;

  div.warningZoom {
    display: flex;
    gap: 9px;
    font-size: 12px;
    line-height: 16px;
  }

  strong {
    font-weight: 900;
  }
`;

const List = styled.ul`
  list-style-type: disc;
  padding: 0 0 0 15px;

  li {
    margin: 0 0 8px 0;
  }

  a {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-decoration: underline;
    color: #5b36f2;
    outline: none;

    &:focus-visible {
      color: #4318cd;
      border: 1px solid #4318cd;
      border-radius: 4px;
    }
    &:hover {
      color: #745ef6;
    }
    &:active {
      color: #4318cd;
    }
  }
`;

const ListTwo = styled.ul`
  list-style-type: disc;
  padding: 0 0 0 15px;

  li {
    margin: 0 0 8px 0;
  }
`;

interface RemoteEventBoxProps {
  urlButtonZoom: string;
  isSubscribed?: boolean;
  isProfessionalTools?: boolean;
}

const RemoteEventBox = ({
  urlButtonZoom,
  isSubscribed,
  isProfessionalTools
}: RemoteEventBoxProps) => {
  const urlWithElipsis = TextHelper.elipsis(urlButtonZoom, 70);
  return (
    <div data-testid="cmp-event-detail-remote-box">
      <Div>
        <img src={IconRemote} alt="" height={16} />
        <span style={{ whiteSpace: 'nowrap', marginRight: 8, fontSize: 14 }}>
          Zoom
        </span>
        {isProfessionalTools && (
          <>
            <Line
              style={{
                width: '1px',
                height: '24px',
                margin: '0 8px 0 0'
              }}
            />
            <img src={IconClass} alt="" height={16} width={16} />
            <span
              style={{ whiteSpace: 'nowrap', marginRight: 8, fontSize: 14 }}
            >
              UTP+class
            </span>
          </>
        )}
        <Line />
      </Div>
      {isSubscribed && (
        <>
          {!isProfessionalTools && (
            <Container>
              <div>
                {!urlButtonZoom && (
                  <div className="warningZoom">
                    <Icon name="alert-circle" size={16} />
                    <p>
                      <strong>No hemos encontrado el enlace a Zoom.</strong>
                      <br /> Reporta este inconveniente con{' '}
                      <Link
                        linkType="external"
                        url="https://saeutp.zendesk.com/"
                        linkName="SAE."
                      />
                    </p>
                  </div>
                )}
                {urlButtonZoom && (
                  <>
                    <p style={{ margin: '0 0 16px' }}>
                      <strong>¿No puedes ingresar?</strong>
                    </p>
                    <div style={{ margin: '0 0 24px 0' }}>
                      <List>
                        <li>
                          Revisa que hayas ingresado con tu correo UTP y tu
                          contraseña de UTP+class.
                        </li>
                        <li>
                          {' '}
                          En caso persista el problema, ingresa a enlace del
                          taller:
                          <a
                            href={urlButtonZoom}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {' '}
                            {urlWithElipsis?.substring(0, 27)}
                            <br />
                            {urlWithElipsis?.substring(
                              27,
                              urlWithElipsis.length
                            )}
                          </a>
                        </li>
                      </List>
                    </div>
                    <ButtonZoom urlZoom={urlButtonZoom} />
                  </>
                )}
              </div>
            </Container>
          )}
          {isProfessionalTools && (
            <Container>
              <div>
                <p style={{ margin: '0 0 16px' }}>
                  <strong>Toma en cuenta</strong>
                </p>
                <ListTwo>
                  <li>
                    {' '}
                    Podrás ingresar a las clases por zoom y ver el contenido en{' '}
                    <Link
                      linkType="external"
                      url="https://class.utp.edu.pe/student/courses"
                      linkName="UTP+class."
                    />
                  </li>
                  <li>
                    Para obtener el certificado, es necesario asistir al 75 % de
                    las sesiones.
                  </li>
                  <li>
                    Puedes anular la inscripción hasta antes del inicio del
                    taller.
                  </li>
                </ListTwo>
              </div>
            </Container>
          )}
        </>
      )}
    </div>
  );
};

export default RemoteEventBox;
